import React from 'react';
const tomes = [{
  number: '01',
  title: 'Arquitectura del Encuadre y Admisión',
  desc: 'Protocolo de admisión, legajo clínico, contrato terapéutico y scripts de primer contacto'
}, {
  number: '02',
  title: 'El Plan Maestro Anual',
  desc: 'Planificación clínica por fases, mapa de ruta del tratamiento y estructura de sesión tipo'
}, {
  number: '03',
  title: 'El Maletín de Intervenciones',
  desc: 'Intervenciones organizadas por problemática, técnicas listas para usar y secuencia terapéutica'
}, {
  number: '04',
  title: 'Intervenciones de Alta Complejidad',
  desc: 'Protocolos para crisis, trauma, duelo, resistencia terapéutica y casos de alta demanda'
}, {
  number: '05',
  title: 'Gestión del Consultorio y Autocuidado',
  desc: 'Organización operativa, política de cancelaciones, honorarios y prevención del burnout'
}, {
  number: '06',
  title: 'El Consultorio Expandido',
  desc: 'Posicionamiento de especialista, transición a particular y soberanía profesional'
}];
const includes = ['Scripts listos para copiar y usar hoy', 'Plantillas de legajo clínico imprimibles', 'Checklists de sesión por tomo', 'Protocolos de crisis y derivación', 'Contratos terapéuticos adaptados a Ley 26.529', 'Planificación semanal y por fases', 'Marco teórico clínico con fundamento', '100% adaptado al psicólogo argentino'];
export function WhatYouGet() {
  return <section className="w-full px-4 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(245,243,255) 0%, rgb(245,243,255) 15%, rgb(245,243,255) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-366">
      <div className="mx-auto max-w-3xl" data-id="element-367">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-368">
          Lo que <span className="text-violet-700" data-id="element-369">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-370">
          6 tomos · +360 páginas · Todo listo para implementar desde hoy
        </p>

        {/* Tomos */}
        <div className="bg-white border border-violet-500/20 rounded-xl overflow-hidden shadow-sm mb-6" data-id="element-371">
          {/* Header */}
          <div className="bg-violet-700 px-5 py-3" data-id="element-372">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-373">
              🧠 LOS 6 TOMOS — Para psicólogos clínicos en Argentina
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-374">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-3" data-id="element-375">
                {/* Número */}
                <span className="shrink-0 text-lg font-black text-violet-700/30 w-8 text-center" data-id="element-376">
                  {tome.number}
                </span>

                {/* Contenido */}
                <div className="flex-1 min-w-0" data-id="element-377">
                  <span className="block text-sm font-black text-gray-900" data-id="element-378">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-379">
                    {tome.desc}
                  </span>
                </div>

                {/* Páginas */}
                <span className="shrink-0 text-[10px] font-bold text-violet-700 bg-violet-500/5 border border-violet-500/20 rounded-full px-2 py-0.5" data-id="element-380">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="bg-white border border-violet-500/20 rounded-xl overflow-hidden shadow-sm" data-id="element-381">
          {/* Header */}
          <div className="bg-violet-500/5 border-b border-violet-500/20 px-5 py-3" data-id="element-382">
            <h3 className="text-sm font-black text-violet-700 m-0" data-id="element-383">
              Cada tomo incluye:
            </h3>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-0 divide-y sm:divide-y-0 divide-gray-100" data-id="element-384">
            {includes.map((item, i) => <div key={item} className={`flex items-start gap-3 px-5 py-3 ${i % 2 === 0 ? 'sm:border-r border-gray-100' : ''}`} data-id="element-385">
                <span className="shrink-0 text-violet-700 font-bold text-sm mt-0.5" data-id="element-386">
                  ✅
                </span>
                <span className="text-xs text-gray-700 leading-5" data-id="element-387">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}